import { Component, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { ChassisFormHandler, LIST_PLUGIN_MODE, LIST_PLUGIN_TYPE, ListPluginOptions, Model, ToastService, trans } from '@kaiser-software/chassis-core';
import { RelationAddressService } from '../../services/relation-address.service';
import { AddressService } from '../../services/address.service';
import { AddressRelationListItem } from '@kaiser-software/donna-core/src/app/addresses/plugins/address-relation/item/address-relation.list-item';

@Component({
    selector: 'donna-address-relation-plugin',
    templateUrl: './address-relation.plugin.html',
    styleUrls: ['./address-relation.plugin.scss'],
    providers: [AddressService, RelationAddressService]
})
/**
 * The component to represent the address relations
 */
export class AddressRelationPlugin implements OnInit, OnDestroy {
    /**
     * Chassis form handler instance injected by the plugin slot, containing the form handler from the page.
     *
     * @type {ChassisFormHandler}
     */
    @Input() public form: ChassisFormHandler; // form handler which processes the main form

    /**
     * Observable containing the page's model instance.
     *
     * @type {Subject<any>}
     */
    @Input() public modelSubject: Subject<Model>;

    public options: ListPluginOptions;

    /**
     * The ToastService instance.
     */
    protected toastService: ToastService;


    constructor(private injector: Injector) {
        this.toastService = injector.get(ToastService);
    }

    /*
     * Init
     */
    ngOnInit() {
        const service = this.injector.get(RelationAddressService);

        this.modelSubject.subscribe((model: Model) => {
            if (model._service) {
                if (model._service.restEndpoint) {
                    if (model.exists()) {
                        service.params({
                            pluralModel: model._service.restEndpoint,
                            idModel: model.id
                        });
                    } else {
                        this.form.success((data, resolve, reject) => {
                            service.params({
                                pluralModel: model._service.restEndpoint,
                                idModel: data.id
                            });

                            resolve();
                        });
                    }
                } else {
                    this.toastService.error('error', 'Model\'s service doesn\t have a rest endpoint!');
                }
            } else {
                this.toastService.error('error', 'Model doesn\'t have a service!');
            }
        });

        this.options = {
            type: LIST_PLUGIN_TYPE.CREATE_EDIT_DELETE,
            mode: LIST_PLUGIN_MODE.LIST,
            title: trans('Addresses'),
            header: true,
            service: service,
            template: AddressRelationListItem,
            columns: [{
                title: trans('Type'),
                name: 'type',
                width: '20%'
            }, {
                title: trans('Street'),
                name: 'street',
                width: '50%'
            }, {
                title: trans('House number'),
                name: 'house_number',
                width: '10%'
            }, {
                title: trans('Zip code'),
                name: 'zip_code',
                width: '20%'
            }],
            modal: {
                titles: {
                    create: trans('Create address'),
                    edit: trans('Edit address')
                },
                form: {
                    service: service
                }
            },
            data: {
                model: this.modelSubject,
                form: this.form
            },
            actions: {
                create: {
                    text: trans('Add a new address')
                }
            }
        };
    }

    /*
     * Cleanup
     */
    ngOnDestroy() {
    }
}


// WEBPACK FOOTER //
// ./libs/donna-core/src/app/addresses/plugins/address-relation/address-relation.plugin.ts